// import components below
import PropTypes from 'prop-types';
import PageHeaderUI from 'components/UI/PageHeaderUI';

// main component
const InventoryHeader = ({ active }) => {
  return (
    <div className='employeesHeader'>
      <PageHeaderUI>
        <h4>Employees Module</h4>
        <p>Dashboard / Employees / {active}</p>
      </PageHeaderUI>
    </div>
  );
};

InventoryHeader.defaultProps = {
  active: '',
};

InventoryHeader.propTypes = {
  active: PropTypes.string,
};

export default InventoryHeader;
